import { config } from '@/config';

const API_URL = `${config.server.url}/api/form`;

type SchoolFeedbackFormId = 'school-report' | 'school-confirm';

type FormField = { label: string; value: string };

type SubmitSchoolFeedbackData = {
  formId: SchoolFeedbackFormId;
  experienceId: string;
  email?: string;
  notes?: string;
  pdfUrl?: string;
};

export const submitSchoolFeedbackForm = async (
  data: SubmitSchoolFeedbackData
): Promise<void> => {
  const fields: FormField[] = [
    { label: 'Experience ID', value: data.experienceId },
    { label: 'Page URL', value: window.location.href },
  ];

  if (data.email) {
    fields.push({ label: 'Email', value: data.email });
  }

  if (data.notes) {
    fields.push({ label: 'Notes', value: data.notes });
  }

  if (data.pdfUrl) {
    fields.push({ label: 'PDF Link', value: data.pdfUrl });
  }

  const response = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ formId: data.formId, fields }),
  });

  if (!response.ok) {
    throw new Error(`Failed to submit form: ${response.status}`);
  }
};
